
const cx = (...arr) => arr.filter(Boolean).join(" ");

export default cx